module.exports = __webpack_public_path__ + "static/media/Roboto-Italic.ad4e0874.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Italic.woff2
// module id = 546
// module chunks = 0